// src/data/site.js

export const SITE = {
  brand: "Din Lee Engineering Pte. Ltd.",
  domain: "https://dinleeengineeringpteltd.com",
  phone: "+65 8530 3990",
  addressLine: "38 Woodlands Ind Pk E1, #05-13",
  cityLine: "Singapore 757700",
  emailPrimary: "sales.shade0606@gmail.com",
  whatsapp: "+6585303890",
  geo: { lat: 1.4426, lng: 103.7926 },
};

export const servicesIndexUrl = () => `${SITE.domain}/services`;
export const serviceUrl = (slug) => `${SITE.domain}/services/${slug}`;

/**
 * ✅ ONLY CHANGE IMAGES HERE
 * Put images in: public/images/...
 * then use "/images/your-file.jpg"
 */
export const SERVICE_IMAGES = {
  // hero banner image for Services page
  servicesHero: "/images/services-hero.jpg",

  // deep section images (optional)
  process: "/images/services-process.jpg",
  materials: "/images/services-materials.jpg",
  quote: "/images/services-quote.jpg",

  // fallback
  fallback: "/images/placeholder.jpg",

  // per-service images
  retractableAwning: {
    card: "/images/Retractable-Awning.png",
    hero: "/images/Retractable-Awning.png",
  },
  loopAwning: {
    card: "/images/Loop-Awning.png",
    hero: "/images/Loop-Awning.png",
  },
  rooftopAwnings: {
    card: "/images/Rooftop-Awnings.png",
    hero: "/images/Rooftop-Awnings.png",
  },
  glassCanopy: {
    card: "/images/Glass-Canopy-Shelter.png",
    hero: "/images/Glass-Canopy-Shelter.png",
  },
  sunshade: {
    card: "/images/Sunshade-Shade-Solution.png",
    hero: "/images/Sunshade-Shade-Solution.png",
  },
  zipTrack: {
    card: "/images/Outdoor-Zip-Track.png",
    hero: "/images/Outdoor-Zip-Track.png",
  },
  rollerBlind: {
    card: "/images/Outdoor-Roller-Blind.png",
    hero: "/images/Outdoor-Roller-Blind.png",
  },
  acpRoof: {
    card: "/images/Aluminium-Composite-Panel.png",
    hero: "/images/Aluminium-Composite-Panel.png",
  },
  polyRoof: {
    card: "/images/Polycarbonate-Roof.png",
    hero: "/images/Polycarbonate-Roof.png",
  },
  flutedRoof: {
    card: "/images/Aluminium-Fluted-Roof.png",
    hero: "/images/Aluminium-Fluted-Roof.png",
  },
  zincRoof: {
    card: "/images/Zinc-Roof.png",
    hero: "/images/Zinc-Roof.png",
  },
  pvcCeiling: {
    card: "/images/PVC-Ceiling.png",
    hero: "/images/PVC-Ceiling.png",
  },
  aluminumCeiling: {
    card: "/images/Aluminum-Ceiling-False-Ceiling.png",
    hero: "/images/Aluminum-Ceiling-False-Ceiling.png",
  },
  metalWork: {
    card: "/images/Metal-Work.png",
    hero: "/images/Metal-Work.png",
  },
  woodenTrellis: {
    card: "/images/Wooden-Trellis.png",
    hero: "/images/Wooden-Trellis.png",
  },
  woodenDecking: {
    card: "/images/Wooden-Decking.png",
    hero: "/images/Wooden-Decking.png",
  },
  renovation: {
    card: "/images/Renovation-General-Contractor.png",
    hero: "/images/Renovation-General-Contractor.png",
  },
};

/* ================= SERVICES ================= */
export const SERVICES = [
  {
    slug: "retractable-awning",
    title: "Retractable Awning",
    desc: "Motorized/manual retractable awnings for homes, shops & outdoor seating.",
    seoTitle: "Retractable Awning Singapore (Motorized / Manual) | Din Lee Engineering",
    seoDesc:
      "Custom retractable awnings in Singapore for homes & shops. Site measurement, fabrication & installation. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.retractableAwning.card,
    heroImage: SERVICE_IMAGES.retractableAwning.hero,
  },
  {
    slug: "loop-awning",
    title: "Loop Awning",
    desc: "Elegant loop awnings for storefronts & walkways with strong frame support.",
    seoTitle: "Loop Awning Singapore | Shopfront & Walkway Awnings | Din Lee",
    seoDesc:
      "Loop awning supply & installation in Singapore for storefronts and walkways. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.loopAwning.card,
    heroImage: SERVICE_IMAGES.loopAwning.hero,
  },
  {
    slug: "rooftop-awnings",
    title: "Rooftop Awnings",
    desc: "Rooftop shade systems engineered for wind/rain conditions in Singapore.",
    seoTitle: "Rooftop Awnings Singapore | Rooftop Shade Systems | Din Lee",
    seoDesc:
      "Rooftop awning and shade solutions in Singapore. Site assessment, fabrication & installation. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.rooftopAwnings.card,
    heroImage: SERVICE_IMAGES.rooftopAwnings.hero,
  },
  {
    slug: "glass-canopy",
    title: "Glass Canopy Shelter",
    desc: "Modern glass canopy shelters with safety glass and robust metal structure.",
    seoTitle: "Glass Canopy Shelter Singapore | Safety Glass Canopy | Din Lee",
    seoDesc:
      "Modern glass canopy shelter supply & installation in Singapore. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.glassCanopy.card,
    heroImage: SERVICE_IMAGES.glassCanopy.hero,
  },
  {
    slug: "sunshade",
    title: "Sunshade / Shade Solution",
    desc: "Custom sunshade solutions for residential, commercial & industrial spaces.",
    seoTitle: "Sunshade & Shade Solution Singapore | Outdoor Shade | Din Lee",
    seoDesc:
      "Custom sunshade and shade solutions in Singapore. Measurement, fabrication & installation. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.sunshade.card,
    heroImage: SERVICE_IMAGES.sunshade.hero,
  },
  {
    slug: "outdoor-zip-track",
    title: "Outdoor Zip Track",
    desc: "Zip track systems for balconies/patios—better comfort, privacy and wind control.",
    seoTitle: "Outdoor Zip Track Singapore | Balcony Zip Track System | Din Lee",
    seoDesc:
      "Outdoor zip track systems in Singapore for balconies and patios. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.zipTrack.card,
    heroImage: SERVICE_IMAGES.zipTrack.hero,
  },
  {
    slug: "roller-blind",
    title: "Outdoor Roller Blind",
    desc: "Outdoor roller blinds to reduce glare, heat and improve privacy.",
    seoTitle: "Outdoor Roller Blind Singapore | Heat & Glare Control | Din Lee",
    seoDesc:
      "Outdoor roller blinds in Singapore for heat control, glare reduction and privacy. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.rollerBlind.card,
    heroImage: SERVICE_IMAGES.rollerBlind.hero,
  },
  {
    slug: "acp-roof",
    title: "ACP Roof",
    desc: "ACP roofing with clean finishing, long durability and waterproofing options.",
    seoTitle: "ACP Roof Singapore | Aluminium Composite Panel Roofing | Din Lee",
    seoDesc:
      "ACP roofing in Singapore with clean finishing and waterproofing options. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.acpRoof.card,
    heroImage: SERVICE_IMAGES.acpRoof.hero,
  },
  {
    slug: "polycarbonate-roof",
    title: "Polycarbonate Roof",
    desc: "Lightweight polycarbonate roofing for patios, car porches & walkways.",
    seoTitle: "Polycarbonate Roof Singapore | Patio & Car Porch Roofing | Din Lee",
    seoDesc:
      "Polycarbonate roofing in Singapore for patios, car porches and walkways. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.polyRoof.card,
    heroImage: SERVICE_IMAGES.polyRoof.hero,
  },
  {
    slug: "aluminium-fluted-roof",
    title: "Aluminium Fluted Roof",
    desc: "Premium fluted aluminium roof panels for modern outdoor aesthetics.",
    seoTitle: "Aluminium Fluted Roof Singapore | Premium Outdoor Roof | Din Lee",
    seoDesc:
      "Aluminium fluted roof installation in Singapore. Measurement, fabrication & installation. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.flutedRoof.card,
    heroImage: SERVICE_IMAGES.flutedRoof.hero,
  },
  {
    slug: "zinc-roof",
    title: "Zinc Roof",
    desc: "Zinc roofing solutions with strong corrosion resistance and neat finish.",
    seoTitle: "Zinc Roof Singapore | Corrosion-Resistant Roofing | Din Lee",
    seoDesc:
      "Zinc roof installation in Singapore with neat finish. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.zincRoof.card,
    heroImage: SERVICE_IMAGES.zincRoof.hero,
  },
  {
    slug: "pvc-ceiling",
    title: "Wood grain ceiling",
    desc: "Wood grain ceiling for interior/exterior areas—easy maintenance & clean look.",
    seoTitle: "Wood grain ceiling Singapore | Easy Maintenance Ceiling Works | Din Lee",
    seoDesc:
      "PWood grain ceiling works in Singapore for clean look and easy maintenance. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.pvcCeiling.card,
    heroImage: SERVICE_IMAGES.pvcCeiling.hero,
  },
  {
    slug: "aluminum-ceiling",
    title: "Aluminum Ceiling / False Ceiling",
    desc: "Aluminium ceiling and false ceiling works for homes & commercial spaces.",
    seoTitle: "Aluminum Ceiling Singapore | False Ceiling Works | Din Lee",
    seoDesc:
      "Aluminum ceiling and false ceiling works in Singapore. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.aluminumCeiling.card,
    heroImage: SERVICE_IMAGES.aluminumCeiling.hero,
  },
  {
    slug: "metal-work",
    title: "Metal Work",
    desc: "Custom metal fabrication: frames, supports, brackets & structural works.",
    seoTitle: "Metal Work Singapore | Custom Metal Fabrication | Din Lee",
    seoDesc:
      "Custom metal work and fabrication in Singapore. Measurement & installation. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.metalWork.card,
    heroImage: SERVICE_IMAGES.metalWork.hero,
  },
  {
    slug: "wooden-trellis",
    title: "Wooden Trellis",
    desc: "Outdoor wooden trellis for gardens, patios & decorative shade structures.",
    seoTitle: "Wooden Trellis Singapore | Outdoor Trellis Installation | Din Lee",
    seoDesc:
      "Wooden trellis installation in Singapore for gardens and patios. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.woodenTrellis.card,
    heroImage: SERVICE_IMAGES.woodenTrellis.hero,
  },
  {
    slug: "wooden-decking",
    title: "Wooden Decking",
    desc: "Decking installation for outdoor flooring—strong, stylish and practical.",
    seoTitle: "Wooden Decking Singapore | Outdoor Deck Installation | Din Lee",
    seoDesc:
      "Wooden decking installation in Singapore for outdoor flooring. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.woodenDecking.card,
    heroImage: SERVICE_IMAGES.woodenDecking.hero,
  },
  {
    slug: "renovation",
    title: "Renovation / General Contractor",
    desc: "General contracting & renovation support for outdoor improvement projects.",
    seoTitle: "Renovation Contractor Singapore | General Contractor | Din Lee",
    seoDesc:
      "Renovation and general contractor support in Singapore for outdoor improvement projects. Call +65 8530 3890.",
    cardImage: SERVICE_IMAGES.renovation.card,
    heroImage: SERVICE_IMAGES.renovation.hero,
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
